/** Session paiement slot (page pending 20 min). */

export const PENDING_DURATION_MS = 20 * 60 * 1000;
const STORAGE_KEY = "alphasniper_pending_payment";

export function savePendingPayment(session) {
  if (!session?.bep20?.paymentId) return;
  const existing = loadPendingPayment();
  const samePayment =
    existing?.session?.bep20?.paymentId === session.bep20.paymentId;
  const payload = {
    session,
    startedAt:
      samePayment && existing?.startedAt ? existing.startedAt : Date.now(),
  };
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore quota */
  }
}

export function loadPendingPayment() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.session?.bep20?.paymentId) return null;
    return data;
  } catch {
    return null;
  }
}

export function clearPendingPayment() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function formatCountdown(msLeft) {
  const total = Math.max(0, Math.floor(msLeft / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

/**
 * After payment is detected (webhook), redirect while countdown remaining
 * is between 15:00 and 9:00 (random instant in that window).
 * For a 20 min timer → between 5 and 11 minutes after payment start.
 */
export const POST_PAY_REMAINING_MAX_MS = 15 * 60 * 1000;
export const POST_PAY_REMAINING_MIN_MS = 9 * 60 * 1000;
/** @deprecated use POST_PAY_REMAINING_* — kept for older imports */
export const POST_PAY_REDIRECT_MIN_MS = PENDING_DURATION_MS - POST_PAY_REMAINING_MAX_MS;
export const POST_PAY_REDIRECT_MAX_MS = PENDING_DURATION_MS - POST_PAY_REMAINING_MIN_MS;
const POST_PAY_REDIRECT_KEY = "alphasniper_post_pay_redirect";

/** Random redirect time: countdown remaining in [9:00, 15:00]. */
export function randomPostPayRedirectDelayMs() {
  const minElapsed = Math.max(0, PENDING_DURATION_MS - POST_PAY_REMAINING_MAX_MS);
  const maxElapsed = Math.max(
    minElapsed,
    PENDING_DURATION_MS - POST_PAY_REMAINING_MIN_MS,
  );
  const span = maxElapsed - minElapsed;
  return minElapsed + Math.floor(Math.random() * (span + 1));
}

export function resolvePostPayRedirectAt({
  startedAt,
  key,
  destination,
  slotName,
}) {
  if (!startedAt || !key) return null;
  const stored = loadPostPayRedirect();
  if (
    stored?.key === key &&
    Number(stored.startedAt) === startedAt &&
    Number(stored.redirectAt) > 0
  ) {
    return Number(stored.redirectAt);
  }
  const redirectAt = startedAt + randomPostPayRedirectDelayMs();
  savePostPayRedirect({
    key,
    startedAt,
    redirectAt,
    destination: destination || null,
    slotName: slotName || null,
  });
  return redirectAt;
}

export function savePostPayRedirect(payload) {
  if (!payload?.redirectAt) return;
  try {
    sessionStorage.setItem(POST_PAY_REDIRECT_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function loadPostPayRedirect() {
  try {
    const raw = sessionStorage.getItem(POST_PAY_REDIRECT_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.redirectAt) return null;
    return data;
  } catch {
    return null;
  }
}

export function clearPostPayRedirect() {
  try {
    sessionStorage.removeItem(POST_PAY_REDIRECT_KEY);
  } catch {
    /* ignore */
  }
}
